import { DATE_FORMAT } from "helpers/common";
import React from "react";

const Columns = ({ handleEditHandler }) => [
  {
    dataField: "weekNo",
    text: "Week No",
    formatter: (_, row) => <span className="text-capitalize">{row?.weekNo}</span>,
  },
  {
    dataField: "year",
    text: "Year",
    formatter: (_, row) => <span className="text-capitalize">{row?.year}</span>,
  },
  {
    dataField: "totalWeeklyBudget",
    text: "Total Weekly Budget",
    formatter: (_, row) => <span className="text-capitalize">{row?.totalWeeklyBudget}</span>,
    sort: true,
    sortCaret: (order, column) => {
      if (!order) return (<span>&nbsp;&nbsp;▲▼</span>); // Default (no sort)
      else if (order === 'asc') return (<span>&nbsp;&nbsp;▲</span>); // Ascending
      else if (order === 'desc') return (<span>&nbsp;&nbsp;▼</span>); // Descending
      return null;
    },
  },
  {
    dataField: "jackpotBudgetTotal",
    text: "Jackpot Budget",
    formatter: (_, row) => <span className="text">{row?.jackpotBudgetTotal}</span>,
    sort: true,
    sortCaret: (order, column) => {
      if (!order) return (<span>&nbsp;&nbsp;▲▼</span>); // Default (no sort)
      else if (order === 'asc') return (<span>&nbsp;&nbsp;▲</span>); // Ascending
      else if (order === 'desc') return (<span>&nbsp;&nbsp;▼</span>); // Descending
      return null;
    },
  },
  {
    dataField: "jackpotBudgetVisible",
    text: "Visible Jackpot Budget",
    formatter: (_, row) => <span className="text">{row?.jackpotBudgetVisible}</span>,
    sort: true,
    sortCaret: (order, column) => {
      if (!order) return (<span>&nbsp;&nbsp;▲▼</span>); // Default (no sort)
      else if (order === 'asc') return (<span>&nbsp;&nbsp;▲</span>); // Ascending
      else if (order === 'desc') return (<span>&nbsp;&nbsp;▼</span>); // Descending
      return null;
    },
  },
  {
    dataField: "jackpotBudgetReserve",
    text: "Reserved Jackpot Budget",
    formatter: (_, row) => <span className="text">{row?.jackpotBudgetReserve}</span>,
    sort: true,
    sortCaret: (order, column) => {
      if (!order) return (<span>&nbsp;&nbsp;▲▼</span>); // Default (no sort)
      else if (order === 'asc') return (<span>&nbsp;&nbsp;▲</span>); // Ascending
      else if (order === 'desc') return (<span>&nbsp;&nbsp;▼</span>); // Descending
      return null;
    },
  },
  {
    text: "Action",
    dataField: "status",
    formatter: (_, row) => (
      <button
        className="fas fa-eye"
        style={{
          fontSize: "16px",
          backgroundColor: "#fff",
          border: "none",
        }}
        title="View / Edit"
        onClick={() =>
          handleEditHandler(row)
        }
      ></button>
    ),
  },
];
export default Columns;
